import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";

export const useUserNotificationStore = defineStore("userNotification", {
  state: () => ({
    notifications: [],
    deadlineNotifications: [],
    unreadNotificationCount: 0,
    deadlineNotificationCount: 0,
    isLoading: false,
  }),

  getters: {
    unreadCount: (state) => state.unreadNotificationCount,
    totalCount: (state) =>
      state.unreadNotificationCount + state.deadlineNotificationCount,
  },

  actions: {
    async fetchNotificationSummary() {
      try {
        const { data } = await axios.get(`${API_URL}/notifications/summary`);
        this.unreadNotificationCount = data.unread_count;
        this.deadlineNotificationCount = data.deadline_count;
        return data;
      } catch (err) {
        console.error("通知件数取得エラー:", err);
        return null;
      }
    },

    async fetchMyNotifications() {
      this.isLoading = true;
      try {
        const { data } = await axios.get(`${API_URL}/notifications/me`);
        this.notifications = data;
        this.unreadNotificationCount = data.filter(
          (notification) => notification.IS_READ_FLG === "0",
        ).length;
        return data;
      } catch (err) {
        console.error("通知取得エラー:", err);
        return [];
      } finally {
        this.isLoading = false;
      }
    },

    async fetchDeadlineNotifications() {
      try {
        const { data } = await axios.get(`${API_URL}/notifications/deadlines`);
        this.deadlineNotifications = data;
        this.deadlineNotificationCount = data.length;
        return data;
      } catch (err) {
        console.error("期限通知取得エラー:", err);
        return [];
      }
    },

    async markAsRead(notificationNo) {
      try {
        await axios.put(`${API_URL}/notifications/${notificationNo}/read`);
        const item = this.notifications.find(
          (notification) => notification.NOTIFICATION_NO === notificationNo,
        );
        if (item && item.IS_READ_FLG === "0") {
          item.IS_READ_FLG = "1";
          this.unreadNotificationCount = Math.max(
            0,
            this.unreadNotificationCount - 1,
          );
        }
      } catch (err) {
        console.error("既読更新エラー:", err);
      }
    },

    async markAllAsRead() {
      const unread = this.notifications.filter(
        (notification) => notification.IS_READ_FLG === "0",
      );
      await Promise.all(
        unread.map((notification) =>
          this.markAsRead(notification.NOTIFICATION_NO),
        ),
      );
    },
  },
});
